/**
 * Cremation module-details request/response shapes.
 * Mirrors backend/src/modules/cremation/cremation.validators.ts.
 */

export type CremationServiceRadius =
  | 'KM_5'
  | 'KM_10'
  | 'KM_20'
  | 'KM_30'
  | 'KM_50';

export type CremationServiceType =
  | 'INDIVIDUAL'
  | 'SHARED'
  | 'WITNESSED'
  | 'ECO_FRIENDLY'
  | 'EMERGENCY'
  | 'SAME_DAY'
  | 'BURIAL'
  | 'PRIVATE_VIEWING';

export type CremationDetailsRequest = {
  service_radius?: CremationServiceRadius;
  home_pickup_available: boolean;
  is_24x7_emergency: boolean;
  cremation_services: CremationServiceType[]; // 1..8 unique
};

export type CremationDetailsResponse = {
  id: string;
  vendor_profile_id: string;
  service_radius: CremationServiceRadius | null;
  home_pickup_available: boolean;
  is_24x7_emergency: boolean;
  cremation_services: CremationServiceType[];
  created_at: string;
  updated_at: string;
};

export const CREMATION_SERVICE_RADIUS_OPTIONS: Array<{
  value: CremationServiceRadius;
  label: string;
}> = [
  { value: 'KM_5', label: '5 km' },
  { value: 'KM_10', label: '10 km' },
  { value: 'KM_20', label: '20 km' },
  { value: 'KM_30', label: '30 km' },
  { value: 'KM_50', label: '50 km' },
];

export const CREMATION_SERVICE_OPTIONS: Array<{
  value: CremationServiceType;
  label: string;
}> = [
  { value: 'INDIVIDUAL', label: 'Individual' },
  { value: 'SHARED', label: 'Shared' },
  { value: 'WITNESSED', label: 'Witnessed' },
  { value: 'ECO_FRIENDLY', label: 'Eco-friendly' },
  { value: 'EMERGENCY', label: 'Emergency' },
  { value: 'SAME_DAY', label: 'Same day' },
  { value: 'BURIAL', label: 'Burial' },
  { value: 'PRIVATE_VIEWING', label: 'Private viewing' },
];
